// extracted by mini-css-extract-plugin
export default {"tabs":"b_b","tab-list":"b_c","tab":"b_d","active":"b_f"};